// UNC-Chapel Hill's undergraduate majors (#2748). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog (catalog.unc.edu): the Programs
// of Study A-Z list gave every major, concentration and track, and each
// program's own catalog page gave the department or school it sits under
// (its breadcrumb). The catalog's Departments page, by division, places the
// departments in the College of Arts and Sciences or the Gillings School of
// Global Public Health; programs filed under a school (business, data and
// information sciences, dentistry, education, journalism, nursing) are
// grouped under that school. Interdisciplinary Studies is run by the Office
// of Undergraduate Education; the Department of Health Sciences page names
// no school, so it stands alone. Left out: minors, and the D.D.S. and
// Pharm.D., which the list also carries. Degree abbreviations are the
// catalog's own (B.S.P.H., B.S.B.A., B.A.Ed., B.Mus., B.F.A as printed).
// The Computer Science and Biomedical Engineering flags quote the admission
// FAQ on intended majors (the college file's `majors` source). The KB's
// majors list was not needed; the catalog is the only source.
const majors = {
    "slug": "university-of-north-carolina-at-chapel-hill",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UNC-Chapel Hill's official 2026-2027 Undergraduate Catalog, grouped by the college or school that offers it, with the degree it leads to. Concentrations and tracks the catalog lists as programs of their own are kept. Minors, certificates and graduate degrees are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UNC-Chapel Hill 2026-2027 Undergraduate Catalog, Departments by division",
                "url": "https://catalog.unc.edu/undergraduate/departments/"
            },
            "majors": [
                {
                    "name": "African, African American, and Diaspora Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "American Studies: American Indian and Indigenous Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies: Arab Cultures Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies: Chinese Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies: Interdisciplinary Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies: Japanese Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies: Korean Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies: Persian Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Asian Studies: South Asian Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology: Quantitative Biology Track",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S.",
                    "flag": "A separate application, usually by the end of your second year.",
                    "flagSource": "majors"
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry: Biochemistry Track",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry: Polymer Track",
                    "degree": "B.S."
                },
                {
                    "name": "Classics: Classical Archaeology",
                    "degree": "B.A."
                },
                {
                    "name": "Classics: Classical Civilization",
                    "degree": "B.A."
                },
                {
                    "name": "Classics: Greek, Latin, and Combined Greek and Latin",
                    "degree": "B.A."
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A.",
                    "flag": "A separate application, usually by the end of your second year.",
                    "flagSource": "majors"
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S.",
                    "flag": "A separate application, usually by the end of your second year.",
                    "flagSource": "majors"
                },
                {
                    "name": "Contemporary European Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science",
                    "degree": "B.A."
                },
                {
                    "name": "Dramatic Art",
                    "degree": "B.A."
                },
                {
                    "name": "Earth and Marine Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.S."
                },
                {
                    "name": "English and Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Exercise and Sport Science: Fitness Professional",
                    "degree": "B.A."
                },
                {
                    "name": "Exercise and Sport Science: General",
                    "degree": "B.A."
                },
                {
                    "name": "Exercise and Sport Science: Sport Administration",
                    "degree": "B.A."
                },
                {
                    "name": "Exercise and Sport Science",
                    "degree": "B.S."
                },
                {
                    "name": "Geography and Environment",
                    "degree": "B.A."
                },
                {
                    "name": "Geological Sciences: Earth Science Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Geospatial Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Germanic and Slavic Languages and Literatures: German Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Germanic and Slavic Languages and Literatures: Russian Language and Culture Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Germanic and Slavic Languages and Literatures: Slavic and East European Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Global Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Management and Society",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Medical Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.Mus."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Peace, War, and Defense",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Public Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies: Jewish Studies Concentration",
                    "degree": "B.A."
                },
                {
                    "name": "Romance Languages: French and Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Romance Languages: Hispanic Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Romance Languages: Hispanic Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Romance Languages: Italian",
                    "degree": "B.A."
                },
                {
                    "name": "Romance Languages: Portuguese",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics and Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.A."
                },
                {
                    "name": "Studio Art",
                    "degree": "B.F.A"
                },
                {
                    "name": "Women's and Gender Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Adams School of Dentistry",
            "source": {
                "label": "UNC-Chapel Hill 2026-2027 Undergraduate Catalog, Adams School of Dentistry",
                "url": "https://catalog.unc.edu/undergraduate/schools-college/dentistry/"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Gillings School of Global Public Health",
            "source": {
                "label": "UNC-Chapel Hill 2026-2027 Undergraduate Catalog, Gillings School of Global Public Health",
                "url": "https://catalog.unc.edu/undergraduate/schools-college/public-health/"
            },
            "majors": [
                {
                    "name": "Biostatistics",
                    "degree": "B.S.P.H."
                },
                {
                    "name": "Community and Global Public Health",
                    "degree": "B.S.P.H."
                },
                {
                    "name": "Environmental Health Sciences",
                    "degree": "B.S.P.H."
                },
                {
                    "name": "Health Policy and Management",
                    "degree": "B.S.P.H."
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S.P.H."
                }
            ]
        },
        {
            "name": "Hussman School of Journalism and Media",
            "source": {
                "label": "UNC-Chapel Hill 2026-2027 Undergraduate Catalog, Hussman School of Journalism and Media",
                "url": "https://catalog.unc.edu/undergraduate/schools-college/media-journalism/"
            },
            "majors": [
                {
                    "name": "Media and Journalism",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Kenan-Flagler Business School",
            "source": {
                "label": "UNC-Chapel Hill 2026-2027 Undergraduate Catalog, Kenan-Flagler Business School",
                "url": "https://catalog.unc.edu/undergraduate/schools-college/kenan-flagler-business-school/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "B.S.B.A."
                }
            ]
        },
        {
            "name": "Office of Undergraduate Education",
            "source": {
                "label": "UNC-Chapel Hill 2026-2027 Undergraduate Catalog, Office of Undergraduate Education",
                "url": "https://catalog.unc.edu/undergraduate/departments/interdisciplinary-studies/"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Data and Information Sciences",
            "source": {
                "label": "UNC-Chapel Hill 2026-2027 Undergraduate Catalog, School of Data and Information Sciences",
                "url": "https://catalog.unc.edu/undergraduate/schools-college/data-information-sciences/"
            },
            "majors": [
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Information Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "UNC-Chapel Hill 2026-2027 Undergraduate Catalog, School of Education",
                "url": "https://catalog.unc.edu/undergraduate/schools-college/education/"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": "B.A.Ed."
                },
                {
                    "name": "Human and Organizational Leadership Development",
                    "degree": "B.A."
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "B.A.Ed."
                }
            ]
        },
        {
            "name": "Department of Health Sciences",
            "source": {
                "label": "UNC-Chapel Hill 2026-2027 Undergraduate Catalog, Department of Health Sciences",
                "url": "https://catalog.unc.edu/undergraduate/departments/health-sciences/"
            },
            "majors": [
                {
                    "name": "Clinical Laboratory Science",
                    "degree": "B.S."
                },
                {
                    "name": "Neurodiagnostics and Sleep Science",
                    "degree": "B.S."
                },
                {
                    "name": "Radiologic Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "UNC-Chapel Hill 2026-2027 Undergraduate Catalog, School of Nursing",
                "url": "https://catalog.unc.edu/undergraduate/schools-college/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "B.S.N."
                }
            ]
        }
    ]
};

export default majors;
